
export default {
  props: {
    total: { type: Number, required: false, default: null },
    limit: { type: Number, required: false, default: 10000 }
  },
  computed: {
    plural () {
      return this.total > 1
    }
  }
}
